import { FC, useState, createContext, useEffect } from 'react';
import { training as trainingService } from 'src/services';
import { SkillEvaluation } from 'src/models/skill/skillEvaluation.model';
import { CURRENT_USER } from 'src/constants';

type SouhaitFormationContext = {
    setSouhaitFormation: () => any;
    setSouhaitFormationDataContext: (idUser, dataValue) => void;
    souhaitFormationDataKO: boolean;
    setSouhaitFormationDataKOContext: (dataValue) => void;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SouhaitFormationContext = createContext<SouhaitFormationContext>(
    {} as SouhaitFormationContext
);

export const SouhaitFormationProvider: FC = ({ children }) => {
    const userData = JSON.parse(localStorage.getItem(CURRENT_USER));
    const [souhaitFormationData, setSouhaitFormationData] = useState<SkillEvaluation[]>(null);
    // check data
    const [souhaitFormationDataKO, setSouhaitFormationDataKO] = useState<boolean>(false);
    const setSouhaitFormationDataKOContext = (dataValue) => {
        setSouhaitFormationDataKO(dataValue);
    };
    const setSouhaitFormationDataContext = (idUser, dataValue) => {
        // check data temp
        if (dataValue == null || dataValue.length == 0) {
            setSouhaitFormationDataKO(false);
        }
        // 
        setSouhaitFormationData(dataValue);
        // check data
        for (let i = 0; i < dataValue.length; i++) {
            if (idUser != 0) {
                if (idUser != userData.id) { // manager
                    if (dataValue[i].managerOpinion == 0 || dataValue[i].managerOpinion == null) {
                        setSouhaitFormationDataKO(true);
                        break;
                    } else {
                        setSouhaitFormationDataKO(false);
                    }
                }
            }
        }
    };
    const setSouhaitFormation = async () => {
        let errorMessage = "";
        if (souhaitFormationData != null) {
            await trainingService.updateManagerOpinionData(souhaitFormationData).then(response => {
                if (!response.data.success) {
                    errorMessage = '- ' + response.data.message;
                }
            }).catch(err => {
                errorMessage = '- ' + err.response.data.message;
            });
        }
        return errorMessage;
    }

    return (
        <>
            <SouhaitFormationContext.Provider value={{
                setSouhaitFormation,
                setSouhaitFormationDataContext,
                souhaitFormationDataKO,
                setSouhaitFormationDataKOContext
            }}>
                {children}
            </SouhaitFormationContext.Provider>
        </>
    );
};
